

import React from "react";
import WomenBody from "./WomenBody";

// Always renders the female body — memberDetails prop removed
const HumanBody = ({ handleChange, selectedSymptoms, onBodyPartClick }) => {
  return (
    <WomenBody
      handleChange={handleChange}
      selectedTags={selectedSymptoms}
      onBodyPartClick={onBodyPartClick}
    />
  );
};

export default HumanBody;

























// "use client";
// import React from "react";
// import WomenBody from "./WomenBody";
// import MenBody from "./MenBody";

// const HumanBody = ({ memberDetails, handleChange, selectedSymptoms }) => {
//   return (
//     <div>
//       {memberDetails === "Male" ? (
//         <MenBody handleChange={handleChange} selectedTags={selectedSymptoms} />
//       ) : (
//         <WomenBody
//           handleChange={handleChange}
//           selectedTags={selectedSymptoms}
//         />
//       )}
//     </div>
//   );
// };

// export default HumanBody;